import React from 'react';
import { Box } from '@mui/material';
import SubscriptionDetails from '../common/components/userProfile/subscriptionDetails/SubscriptionDetails';
import ProfileLayout from '../common/components/userProfile/ProfileLayout';

const ProfileSubscriptionPage: React.FC = () => {
  return (
    <ProfileLayout>
      <Box>
        <SubscriptionDetails />
      </Box>
    </ProfileLayout>
  );
};

export default ProfileSubscriptionPage;
